import { TinyEmitter } from 'tiny-emitter';
import { onMounted, onUnmounted } from 'vue';

const emitter = new TinyEmitter();

export enum EmitterEvent {
  TitleClick = 'title-click',
  CardChange = 'card-change',
  CommonPreviewIntersect = 'common-preview-intersect',
  ControlTableSelect = 'control-table-select',
  CounterpartiesTableSelect = 'counterparties-table-select',
}

export function useEmitter<T>(event: EmitterEvent, fn: (...args: T[]) => void) {
  onMounted(() => emitter.on(event, fn));
  onUnmounted(() => emitter.off(event, fn));
}

export default emitter;
